type UploadImageParams = {
  imageBlob: Blob;
};

export async function uploadImage({ imageBlob }: UploadImageParams) {
  try {
    const formData = new FormData();
    formData.append('file', imageBlob);
    const response = await fetch(`/api/onboarding/image`, {
      method: 'POST',
      credentials: 'same-origin',
      body: formData,
    });
    let error;
    let json;
    if (response.ok) {
      json = await response.json();
    } else {
      switch (response.status) {
        case 400:
          error = 'Missing image';
          break;
        default:
          error = 'Unexpected error';
          break;
      }
    }
    return { response, json, error };
  } catch (err) {
    throw new Error('Unexpected error');
  }
}
